import { createSlice } from "@reduxjs/toolkit";

export interface iUserCSRFTokenState {
    csrfToken: string | null;
    isLoading: boolean;
}

const initialState: iUserCSRFTokenState = {
    csrfToken: null,
    isLoading: false,
};

export const userCSRFTokenSlice = createSlice({
    name: 'userCSRFToken',
    initialState,
    reducers: {
        setCSRFToken: (state, action) => {
            state.csrfToken = action.payload;
        },
        clearCSRFToken: (state) => {
            state.csrfToken = null;
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        }
    }
});

export const { setCSRFToken, clearCSRFToken, setLoading } = userCSRFTokenSlice.actions;
export default userCSRFTokenSlice.reducer;